import { render, staticRenderFns } from "./AppEngSpeakingAssessment.vue?vue&type=template&id=b890276c&scoped=true"
import script from "./AppEngSpeakingAssessment.vue?vue&type=script&lang=ts"
export * from "./AppEngSpeakingAssessment.vue?vue&type=script&lang=ts"
import style0 from "./AppEngSpeakingAssessment.vue?vue&type=style&index=0&id=b890276c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b890276c",
  null
  
)

export default component.exports